var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_30290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 11.963A2.99 2.99 0 0115.125 9a2.99 2.99 0 012.625-2.963V3.75H1.25v2.287A2.99 2.99 0 013.875 9a2.99 2.99 0 01-2.625 2.963v2.287h16.5v-2.287zm.375-5.213a2.05 2.05 0 00-.375.037A2.248 2.248 0 0015.875 9c0 1.11.81 2.033 1.875 2.213.12.022.247.037.375.037s.255-.015.375-.037v3.412c0 .21-.165.375-.375.375H.875a.371.371 0 01-.375-.375v-3.412c.12.022.248.037.375.037s.255-.015.375-.037A2.248 2.248 0 003.125 9c0-1.11-.81-2.032-1.875-2.213a2.05 2.05 0 00-.375-.037 2.05 2.05 0 00-.375.037V3.375C.5 3.165.665 3 .875 3h17.25c.21 0 .375.165.375.375v3.412a2.05 2.05 0 00-.375-.037zM5 10.875a.375.375 0 00.75 0v-3.75a.375.375 0 00-.75 0v3.75zm8.625.375a.375.375 0 01-.375-.375v-3.75a.375.375 0 01.75 0v3.75a.375.375 0 01-.375.375zm-3.452-3.189c.014.037.05.064.092.064h1.845c.074 0 .105.088.046.13l-1.495 1.039a.09.09 0 00-.039.075c0 .01.002.02.004.028l.572 1.682c.021.067-.057.121-.116.08l-1.494-1.04a.1.1 0 00-.115 0l-1.492 1.04c-.059.041-.137-.013-.115-.08l.57-1.682a.09.09 0 00-.035-.103s-.993-.69-1.494-1.04c-.06-.04-.028-.13.046-.13h1.845a.097.097 0 00.093-.063l.569-1.682c.022-.066.12-.066.142 0l.571 1.682z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_30290"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h18v18H0z"
  })))));
}
SvgLiveEvents.displayName = 'LiveEvents';
export default SvgLiveEvents;